const header = {
  ui: {},

  init: function () {
    this.opened = false
    this.isMobile = false

    this.bindUI()
    this.bindEvents()
  },

  bindUI: function bindUI() {
    this.ui.$header = document.querySelector('.js-header')
    this.ui.$menuToggle = document.querySelector('.js-toggle-menu')
    this.ui.$mainLinks = document.querySelectorAll(
      '.js-header-has-submenu .js-header-main-link',
    )
    this.ui.$openSearch = $('.js-open-search')
    this.ui.$poppinSearch = $('.js-poppin-search')
    this.ui.$closeSearch = $('.js-close-search')
  },

  bindEvents: function bindEvents() {
    if (this.ui.$menuToggle) {
      this.ui.$menuToggle.addEventListener('click', () => this.toggleMenu())
    }
    if (this.ui.$mainLinks) {
      this.ui.$mainLinks.forEach((link) => {
        link.addEventListener('click', (e) => {
          if (this.opened) {
            e.preventDefault()
            e.stopPropagation()

            const parent = e.currentTarget.parentNode

            if (parent.classList.contains('js-submenu-opened')) {
              parent.classList.remove('js-submenu-opened')
            } else {
              parent.classList.add('js-submenu-opened')
            }
          }
        })
      })
    }

    
    window.addEventListener('resize', () => {
      this.resize()
    })
    this.resize()

    this.ui.$openSearch.on('click', this.openSearch.bind(this))
    this.ui.$closeSearch.on('click', this.closeSearch.bind(this))
  },

  toggleMenu: function () {
    if (this.opened) {
      this.ui.$header.classList.remove('header--opened')
    } else {
      this.ui.$header.classList.add('header--opened')
    }

    this.opened = !this.opened
  },

  openSearch: function () {
    this.ui.$poppinSearch.show()
  },

  closeSearch: function () {
    this.ui.$poppinSearch.hide()
  },
  resize: function() {
    this.isMobile = window.innerWidth <= 900
    
    if (this.isMobile) {
      this.ui.$header.classList.add('header--mobile')
    } else {
      this.ui.$header.classList.remove('header--mobile')
    }
  }
}

module.exports = header
